<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <!--  Tab General -->
                <CTab :title="$t('general')"> 
                    <TagGeneralTab :tagUuid="uuid" :mode="viewType" />
                </CTab>
                <!-- <CTab :title="$t('sub_tags')" :disabled="viewType != 'edit'">
                    <SubTagTab :tagUuid="uuid" v-if="viewType == 'edit'"/>
                </CTab> -->
            </CTabs>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import TagGeneralTab from "~/pages/Admin/Headers/Components/TagGeneralTab.vue";
import SubTagTab from "~/pages/Admin/Headers/Components/SubTagTab.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";
import formMixin from "~/mixins/form";

/** Others */
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";

export default {
    name: "TagViewPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, formMixin, validationMixin],

    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },

    components: {
        ButtonBack,
        TagGeneralTab,
        SubTagTab
    },
    data() {
        return {
        };
    },
    computed: {
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.query.uuid;
        },
    },
    methods: {

    },
    async mounted() {
        this.updatePageLoading(false);
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
</style>
